module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Avalicação do bolsista pelo coordenador"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('c-selecionar-nota', {
    attrs: {
      "label": "Inteiração do aluno com o Plano de Trabalho a ser cumprir",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Atuação do bolsista na execução do Plano de Trabalho estabelecido",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Assiduidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Iniciativa",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Responsabilidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Capacidade de Interação com o público-atingido ",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Participação nas atividades do programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Integração com a equipe",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Capacidade de organização e gerenciamento de rotina",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Participação em eventos",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver-se do ponto de vista pessoal",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver-se do ponto de vista acadêmico.",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Adquirir novos conhecimentos",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Confrontar a formação acadêmica com a prática",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar ações que integram ensino, pesquisa e extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar práticas político-sociais",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Perceber a inserção social de sua profissão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Ajudar a solucionar problemas identificados",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Avaliar criticamente seu processo de formação",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver ações multidisciplinares/interdisciplinaresInfluir na inserção de outros alunos no programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Influir na inserção de outros alunos no programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Ser autor ou co-autor de publicação ou outro produto acadêmico",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Conhecer o Plano Nacional de Extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Conhecer a política de extensão da Universidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Adquirir capacidade de organização e gerenciamento de rotina",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar a dinâmica de ações interinstitucionais",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('v-layout', [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                    Relatório parcial de atividades desempenhada pelo bolsista no período (descrição sucinta).\n                  ")])]), _vm._v(" "), _c('v-layout', [_c('v-textarea', {
    attrs: {
      "rows": 5,
      "multi-line": "",
      "counter": "500",
      "rules": _vm.couterRules,
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.avaliacao.relatorio),
      callback: function($$v) {
        _vm.$set(_vm.avaliacao, "relatorio", $$v)
      },
      expression: "avaliacao.relatorio"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46526be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/avaliacao-coordenador.vue
// module id = 401
// module chunks = 0